export default "assets/images/icons/plus-circle-a28422ee.svg";